import { createFileRoute } from '@tanstack/react-router';
import { PlannerPlaceholder } from '../components/PlannerPlaceholder.js';
import { useDoorStore } from '../stores/doorStore.js';

function CartPlaceholder() {
  const reference = useDoorStore((state) => state.cartReference);
  return (
    <PlannerPlaceholder id="cart">
      {reference && (
        <p data-name="cart-saved-reference" className="mt-4 text-sm text-gray-700">
          Design Reference: <strong>{reference}</strong>
        </p>
      )}
    </PlannerPlaceholder>
  );
}

export const Route = createFileRoute('/_planner/cart')({
  component: CartPlaceholder,
});
